/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import jsonExport from "jsonexport/dist";

import {
  Card,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  DateField,
  DateInput,
  downloadCSV,
  FilterButton,
  FunctionField,
  ListContextProvider,
  ListToolbar,
  NumberField,
  RefreshButton,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
} from "react-admin";

import { Pagination } from "../../../components/Pagination";
import { ChevronRightIcon } from "../../../components/common/iconography";
import { CustomField } from "../../../components/common/CustomFields";
import ExportButton from "../../../components/common/ExportButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { LowInventoryIcon } from "../../../components/common/LowInventoryIcon";
import { ProductLinkIcon } from "../../../components/common/ProductLinkIcon";
import { SearchField } from "../../../components/common/SearchField";
import CustomizableDatagrid from "../../../components/common/ra-customizable-datagrid";
import { ageRenderer } from "../../../components/common/AgeRenderer";

import { InventoryStatus, LotTypes } from "../../../utils/constants";
import {
  exportCustomField,
  normalizeValue,
  piecesRenderer,
} from "../../../utils/utils";
import { useSearchableList } from "../../../dataProvider/useSearchableList";
import { useUser } from "../../../authenticatorApp/UserContext";

const useStyles = makeStyles((theme) => ({
  totals: {
    marginLeft: theme.spacing(2),
  },
}));

const exporter = (inventories) => {
  const customHeaderMap = new Map();
  debugger;

  const inventoriesForExport = inventories.map((inventory) => {
    const inventoryForExport = {
      inventoryId: inventory.id,
      productCode: inventory.productCode,
      productName: inventory.productName,
      lotNumber: inventory.lotNumber,
      poNumber: inventory.poNumber,
      carTralNumber: inventory.inboundShipment?.railCarNumber
        ? inventory.inboundShipment.railCarNumber
        : "",
      dateReceived: inventory.receivedAt
        ? new Date(inventory.receivedAt).toLocaleDateString()
        : "",
      quantityOnHand: inventory.quantityOnHand,
      quantityCommitted: inventory.quantityCommitted,
      UOM: inventory.inventoryUOM,
      pieces: inventory.pcs || inventory.product?.pcs || "",
    };

    if (inventory.customFields?.length > 0) {
      debugger;
      inventory.customFields.forEach((field) => {
        exportCustomField(field, inventoryForExport, customHeaderMap);
      });
    }

    return inventoryForExport;
  });

  jsonExport(inventoriesForExport, { rename: ["inventoryId"] }, (err, csv) => {
    downloadCSV(csv, `inventories_${new Date().toLocaleDateString()}`); // download as 'inventories_DATE.csv` file
  });
};

const InventorySearchField = (props) => {
  const listContext = useListContext(props);
  const { displayedFilters, filterValues, setFilters } = listContext;
  const { label, alwaysOn } = props;

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const normalizedValue = normalizeValue(value);
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { productName: { matchPhrasePrefix: `${value}` } },
            { productName: { wildcard: `*${value}*` } },
            { productCode: { matchPhrasePrefix: `${value}` } },
            { productCode: { wildcard: `*${value}*` } },
            { lotNumber: { matchPhrasePrefix: `${value}` } },
            { lotNumber: { wildcard: `*${value}*` } },
            // { normalizedPoNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            // { normalizedRailCarNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (appUser, isXSmall) => {
  const commodities = appUser.reloadYard.activeYardCommodities.items;

  return [
    <SelectInput
      source="areaId.eq"
      label="Area"
      variant="outlined"
      resettable
      alwaysOn={!isXSmall}
      choices={appUser?.reloadYard.areas.items}
      allowEmpty
    />,
    <InventorySearchField label="Search" alwaysOn />,
    <SelectInput
      source="reloadYardCommodityId.eq"
      label="Load Type"
      variant="outlined"
      resettable
      choices={commodities}
      optionText="commodity.name"
      allowEmpty
    />,
    <SelectInput
      source="lotType.eq"
      label="Lot Type"
      choices={LotTypes}
      allowEmpty
      variant="outlined"
      resettable
    />,
    <DateInput
      source="receivedAt.lte"
      label="Received before..."
      variant="outlined"
      resettable
      onKeyPress={(event) => event.preventDefault()}
    />,
    <DateInput
      source="receivedAt.gte"
      label="Received after..."
      variant="outlined"
      resettable
      onKeyPress={(event) => event.preventDefault()}
    />,
  ];
};

const ListActions = (props) => {
  const { isXSmall } = props;
  const { resource, total } = useListContext();

  return !isXSmall ? (
    <TopToolbar>
      <FilterButton />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        exporter={exporter}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

export const InventoryList = (props) => {
  const { appUser } = useUser();
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const isMedium = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [defaultFilter] = useState({
    reloadYardId: appUser.reloadYardId,
    statusAccountIdProductNameLotNumber: {
      beginsWith: {
        status: InventoryStatus.STORED,
        accountId: appUser.accountId,
      },
    },
  });

  const defaultSearchFilter = {
    reloadYardId: { eq: appUser?.reloadYardId },
    status: { eq: InventoryStatus.STORED },
    accountId: { eq: appUser.accountId },
  };

  // Include key & search to display default sort order.
  const defaultSort = {
    field: `{"key":"inventoryByStatusByAccountIdByProductByLot", "search":"productName"}`,
    order: "ASC",
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Inventory",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "inventories",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Inventory" />} />
      <ListToolbar
        {...props}
        filters={getListFilters(appUser, isMedium)}
        actions={<ListActions isXSmall={isXSmall} />}
      />
      <Card className={classes.root}>
        <InventoryGrid
          appUser={appUser}
          isXSmall={isXSmall}
          isMedium={isMedium}
        />
        <PaginationToolbar {...props} />
      </Card>
    </ListContextProvider>
  );
};

const PaginationToolbar = (props) => {
  const classes = useStyles();
  const listContext = useListContext(props);
  const [total, setTotal] = useState("");
  var formatter = new Intl.NumberFormat("en-US");

  useEffect(() => {
    let totalsMap = {};

    if (listContext?.ids?.length > 0 && listContext?.data) {
      for (const id of listContext.ids) {
        const uom = listContext.data[id].inventoryUOM;

        if (totalsMap[uom]) {
          totalsMap[uom] += listContext.data[id].quantityOnHand;
        } else {
          totalsMap[uom] = listContext.data[id].quantityOnHand;
        }
      }
    }

    const totals = Object.keys(totalsMap)?.length;
    let totalString = "";

    if (totals >= 0) {
      totalString = "Total: ";
      const parts = [];

      for (const [key, value] of Object.entries(totalsMap)) {
        parts.push(`${formatter.format(value)} ${key}`);
      }
      totalString += parts.join(", ");
    }
    setTotal(totalString);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listContext]);

  return (
    <Grid container direction="row" spacing={1} alignItems="center">
      <Hidden mdDown>
        <Grid item md={5} lg={5}>
          <Typography className={classes.totals}>
            {" "}
            {total && `${total}`}{" "}
          </Typography>
        </Grid>
      </Hidden>
      <Grid item xs={12} md={7}>
        <Pagination {...props} {...listContext} />
      </Grid>
    </Grid>
  );
};

const InventoryGrid = ({ appUser, ...props }) => {
  const { isXSmall, isMedium } = props;
  const account = appUser.account;

  const accountFields =
    account?.inventoryCustomFields?.length > 0
      ? account.inventoryCustomFields
      : [];
  const customColumns = [];
  const customGridFields = accountFields
    ? accountFields.map((field, index) => {
        customColumns.push(field.name);
        return (
          <CustomField
            source={`customFields[${index}]`}
            field={field}
            label={field.name}
            sortable={true}
          />
        );
      })
    : [];

  return isXSmall ? (
    <SimpleList
      primaryText={(record) => record.productName}
      secondaryText={(record) =>
        `${record.quantityOnHand} ${record.inventoryUOM}`
      }
      tertiaryText={(record) => record.lotNumber}
      leftIcon={(record) => <LowInventoryIcon record={record} />}
      rightIcon={() => (
        <ChevronRightIcon
          fontSize="large"
          color="secondary"
          style={{ marginLeft: 40, marginTop: 10 }}
        />
      )}
      linkType="show"
    />
  ) : isMedium ? (
    <CustomizableDatagrid
      rowClick="show"
      storageProp={`InventoryList_${account?.id}_small`}
      defaultColumns={["productName", "lotNumber", "quantityOnHand"]}
    >
      {[
        <ProductLinkIcon sortable={false} />,
        <TextField
          source="productName"
          label="Product"
          sortable={true}
          sortBy={`{"key":"inventoryByStatusByAccountIdByProductByLot", "search":"productName"}`}
        />,
        <FunctionField source="pcs" label="Pieces" render={piecesRenderer} />,
        <TextField source="lotNumber" label="Lot Number" sortable={true} />,
        <TextField source="poNumber" label="PO Number" sortable={true} />,
        <NumberField source="quantityOnHand" label="Stocked" sortable={true} />,
        ...customGridFields,
      ]}
    </CustomizableDatagrid>
  ) : (
    <CustomizableDatagrid
      rowClick="show"
      storageProp={`InventoryList_${account?.id}_large`}
      defaultColumns={[
        "productCode",
        "productName",
        "lotNumber",
        "receivedAt",
        "quantityOnHand",
        ...customColumns,
      ]}
    >
      {[
        <ProductLinkIcon sortable={false} />,
        <TextField source="productCode" label="Product Code" sortable={true} />,
        <TextField
          source="productName"
          label="Product"
          sortable={true}
          sortBy={`{"key":"inventoryByStatusByAccountIdByProductByLot", "search":"productName"}`}
        />,
        <FunctionField source="pcs" label="Pieces" render={piecesRenderer} />,
        <TextField source="lotNumber" label="Lot Number" sortable={true} />,
        <TextField source="poNumber" label="PO Number" sortable={true} />,
        <TextField
          source="railCarNumber"
          label="Car/Trl. No."
          sortable={false}
        />,
        <DateField source="receivedAt" label="Received" sortable={true} />,
        <FunctionField
          source="turnDays"
          label="Age"
          sortable={false}
          render={ageRenderer}
        />,
        <NumberField
          source="quantityOnHand"
          label="Qty. Stocked"
          sortable={true}
        />,
        <NumberField
          source="quantityCommitted"
          label="Qty. Committed"
          sortable={true}
        />,
        <TextField source="inventoryUOM" label="UOM" sortable={false} />,
        <LowInventoryIcon
          source="lowAlert"
          label="Low Stock"
          sortable={false}
        />,
        ...customGridFields,
        <ShowButton />,
      ]}
    </CustomizableDatagrid>
  );
};
